'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/payment-pages/payment-success.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _domain = require('@marmalade/domain');
var _domain2 = _interopRequireDefault(_domain);
var _updateForm = require('@marmalade/form/lib/actions/update-form');
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _selectors = require('@marmalade/query/lib/selectors');
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _selectors2 = require('../quote/selectors');
var _advertisment = require('./advertisment');
var _advertisment2 = _interopRequireDefault(_advertisment);
var _notificationPage = require('./notification-page');
var _notificationPage2 = _interopRequireDefault(_notificationPage);
var _notificationTelephone = require('./notification-telephone');
var _notificationTelephone2 = _interopRequireDefault(_notificationTelephone);
var _policyInformation = require('./policy-information');
var _policyInformation2 = _interopRequireDefault(_policyInformation);
var _selectors3 = require('../renewal/selectors');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _componentThemes$newB = _themes.componentThemes.newBusinessOrderStatus,
  orderStatusStyle = _componentThemes$newB.orderStatusStyle,
  orderStatusTheme = _componentThemes$newB.orderStatusTheme;
var levelData = [{
  icon: 'car-key',
  heading: 'Thinking of buying your own car?',
  body: 'A brand new car may be more affordable than you think with our unique car and insurance scheme!',
  cta: {
    text: 'Find out more',
    link: 'https://www.wearemarmalade.co.uk/cars-for-young-drivers'
  }
}, {
  icon: 'star',
  heading: 'Review us on Trustpilot',
  body: "We'd be really greatful if you could spare a few minutes to leave a review about us on Trustpilot.",
  cta: {
    text: 'Leave a review',
    link: 'https://www.trustpilot.com/evaluate/wearemarmalade.co.uk?stars=5'
  }
}, {
  icon: 'chat',
  heading: 'Share with friends',
  body: 'Boast to your friends on Twitter and start arranging your roadtrip adventures!',
  cta: {
    text: 'Post on Twitter',
    link: 'https://twitter.com/intent/tweet?text=I%27ve%20just%20bought%20Learner%20Driver%20Insurance%20from%20Marmalade!'
  }
}];
var PaymentSuccess = function (_Component) {
  _inherits(PaymentSuccess, _Component);
  function PaymentSuccess() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, PaymentSuccess);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentSuccess.__proto__ || Object.getPrototypeOf(PaymentSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: true,
      errorType: 'none'
    }, _this.firePurchaseEvent = function () {
      var sessionId = 'policy_' + _this.props.policyId;
      var dataLayer = window.dataLayer || [];
      dataLayer.push({
        aa: {
          ecommerce: null
        }
      });
      dataLayer.push({
        event: 'aa_purchase',
        aa: {
          purchase_type: 'renewal',
          ecommerce: {
            transaction_id: _this.props.policyId,
            tax: '0',
            payment_type: '',
            currency: 'GBP',
            value: _this.props.premium,
            coupon: _this.props.promoCode,
            items: [{
              item_id: 'LDI',
              coupon: _this.props.promoCode,
              price: _this.props.premium,
              item_brand: 'Marmalade',
              item_category: 'car',
              item_variant: _this.props.cover + 'days',
              index: 1,
              quantity: 1
            }]
          }
        }
      });

      // Now we save it so we know on page refresh that it's not new
      _this.setSession(Object.assign({}, _this.getSession(), _defineProperty({}, sessionId, {
        startDate: _this.props.coverStartDate // this is so we can wipe the form after and retain the date for the render
      })));
      _this.props.stages.forEach(function (stage) {
        _this.props.resetForm(stage.formId);
      });
    }, _this.getSession = function () {
      return sessionStorage.getItem('LDI_' + _this.props.type + '_SUCCESS') ? JSON.parse(sessionStorage.getItem('LDI_' + _this.props.type + '_SUCCESS')) : undefined;
    }, _this.setSession = function (data) {
      return sessionStorage.setItem('LDI_' + _this.props.type + '_SUCCESS', JSON.stringify(data));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(PaymentSuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.props.premium) {
        this.props.history.push('/login');
        return;
      }
      if (this.props.policyId.length) {
        // Ensure a session exists
        if (!this.getSession()) {
          this.setSession({});
        }
        var sessionId = 'policy_' + this.props.policyId;
        if (!this.getSession()[sessionId] && this.props.coverStartDate.length) {
          // We know it's a new purchase if it's not in session so we tell GA
          // this.props.coverStartDate is an empty array[] if you are visiting the URL not coming from SagePay,
          // so it's only a valid visit if that prop array has values
          setTimeout(function () {
            _this2.firePurchaseEvent();
          }, 0);
        } else {
          this.props.history.push('/login'); // Redirect to login if they have been here before.
        }
      } else if (this.props.vendorTx.length) {
        this.setState({
          errorType: 'databaseError'
        });
      } else {
        window.location.href = (0, _domain2.default)('www.wearemarmalade') + '/learner-driver-insurance';
      }
      this.setState({
        loading: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        theme = _props.theme,
        policyId = _props.policyId,
        container = _props.container,
        type = _props.type,
        hasDonated = _props.hasDonated;
      if (this.state.loading) {
        return _react2.default.createElement(_loading2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 170
          },
          __self: this
        });
      }
      if (this.state.errorType === 'databaseError') {
        return _react2.default.createElement(_notificationPage2.default, {
          container: container,
          text: _react2.default.createElement(_react.Fragment, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 177
            },
            __self: this
          }, 'Sorry! It looks like something went wrong with your order confirmation. Please', ' ', type === 'RENEWAL' ? _react2.default.createElement(_reactRouterDom.Link, {
            to: '/account/dashboard',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 180
            },
            __self: this
          }, 'visit the dashboard') : _react2.default.createElement(_reactRouterDom.Link, {
            to: '/login',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 182
            },
            __self: this
          }, 'log in'), ' ', 'to check the status of your policy, or give us a call on ', _react2.default.createElement(_notificationTelephone2.default, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 184
            },
            __self: this
          }), ' to confirm your payment and insurance is confirmed.'),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 174
          },
          __self: this
        });
      }
      return _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192
        },
        __self: this
      }, _react2.default.createElement(_policyInformation2.default, {
        container: container,
        type: type,
        data: {
          policyId: policyId,
          coverStartDate: this.getSession()['policy_' + this.props.policyId] ? this.getSession()['policy_' + this.props.policyId].startDate.join('/') : this.props.coverStartDate.join('/')
        },
        hasDonated: hasDonated,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 193
        },
        __self: this
      }), orderStatusTheme(theme)[orderStatusStyle('advertisment')] && _react2.default.createElement(_advertisment2.default, {
        data: levelData,
        container: container,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 205
        },
        __self: this
      }));
    }
  }]);
  return PaymentSuccess;
}(_react.Component);
PaymentSuccess.propTypes = {
  theme: _propTypes.object.isRequired,
  coverStartDate: _propTypes.array,
  history: _propTypes.object.isRequired,
  resetForm: _propTypes.func.isRequired,
  price: _propTypes.string,
  policyId: _propTypes.string,
  vendorTx: _propTypes.string,
  dlAttribution: _propTypes.string,
  type: _propTypes.string.isRequired,
  failureLink: _propTypes.string.isRequired,
  stages: _propTypes.array.isRequired,
  container: _propTypes.bool.isRequired,
  sku: _propTypes.string.isRequired,
  hasDonated: _propTypes.bool,
  cover: _propTypes.string,
  premium: _propTypes.string,
  promoCode: _propTypes.string
};
PaymentSuccess.defaultProps = {
  coverStartDate: [],
  policyId: '',
  price: '',
  vendorTx: '',
  cover: '',
  premium: '',
  promoCode: ''
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state, ownProps) {
  var cover = ownProps.type === 'RENEWAL' ? (0, _selectors3.getSnapshot)(state, 'renewalStage5').values.cover : (0, _fieldInfo.getValue)(state, ownProps.stages[ownProps.stages.length - 1].formId, 'cover');
  var premium = (0, _selectors2.getQuotePremium)(state, cover);
  return {
    dlAttribution: (0, _selectors.getQuery)(state, 'dlAttribution') || (0, _selectors2.getDlAttribution)(state),
    policyId: (0, _selectors.getQuery)(state, 'transactionId'),
    vendorTx: (0, _selectors.getQuery)(state, 'vendorTxCode'),
    coverStartDate: (0, _fieldInfo.getValue)(state, ownProps.stages[ownProps.stages.length - 1].formId, 'coverStartDate'),
    price: (0, _selectors.getQuery)(state, 'price'),
    hasDonated: (0, _selectors.getQuery)(state, 'donation') === '1.00',
    promoCode: (0, _fieldInfo.getValue)(state, ownProps.stages[ownProps.stages.length - 1].formId, 'promoCode'),
    cover: cover,
    premium: premium
  };
}, {
  resetForm: _updateForm.resetForm
})((0, _glamorous.withTheme)(PaymentSuccess)));